export const planServiceFrequencyConstants = {
  ID: 'id',

  FREQUENCY: 'frequency',
  FREQUENCY_LABEL: 'Frequency',

  ORDER: 'order',
  ORDER_LABEL: 'Order',

  DISPLAY: 'frequency_display',
  DISPLAY_LABEL: 'Display',
};
